export const ADD_PARTNERS_CRUD_SOURCE_KEY = 'globalPartners-addPartners'
